import { render, staticRenderFns } from "./PreInscripcion.vue?vue&type=template&id=e2486360"
import script from "./PreInscripcion.vue?vue&type=script&lang=js"
export * from "./PreInscripcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports